module.exports = __webpack_public_path__ + "static/team-81b71841bb1904d3f29dfdf21fa895f3.jpg";